import { render, staticRenderFns } from "./ProductsTagFilter.vue?vue&type=template&id=db2a491e&"
import script from "./ProductsTagFilter.vue?vue&type=script&lang=js&"
export * from "./ProductsTagFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "25bc0992"
  
)

export default component.exports